<template>
	<div class="confirmation-popup survey-popup" :class="`${$route.path.startsWith('/gop/') ? 'gop-modal' : 'drc-modal'}`" v-if="doShowDialog">
		<div class="confirmation-dialog" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-duration="400">
			<div class="confirmation-content">
				<h3>{{ $t('common.surveyQuestions') }}</h3>

				<div class="survey-container">
					<template v-for="(question, idx) in questions">
						<div class="question question-multiple" v-if="question.answerType === 'MULTIPLE'" :key="'question' + idx + question.id">
							<div class="question-text">
								<span class="question-text-span">{{ question.question }}</span>
							</div>
							<div class="question-options question-options-multiple">
								<div class="option" v-for="(option, index) in question.drcSurveyAnswers" :key="'answer' + index + idx + option.id" @click="toggleOptions(option, question)">
									<input type="checkbox" :value="option.id" v-model="question.answer" />
									<label>{{ option.answer }}</label>
								</div>
								<textarea v-model="question.comment"></textarea>
							</div>
						</div>

						<div class="question question-single" v-if="question.answerType === 'SINGLE'" :key="'question' + idx + question.id">
							<div class="question-text">
								<span class="question-text-span">{{ question.question }}</span>
							</div>
							<div class="question-options question-options-single">
								<div class="option" v-for="(option, index) in question.drcSurveyAnswers" :key="'answer' + index + idx + option.id" @click="toggleOptions(option, question)">
									<input type="radio" :value="option.id" v-model="question.answer" />
									<label>{{ option.answer }}</label>
								</div>
							</div>
						</div>

						<div class="question question-textarea" v-if="question.answerType === 'TEXT'" :key="'question' + idx + question.id">
							<div class="question-text">
								<span class="question-text-span">{{ question.question }}</span>
							</div>
							<textarea v-model="question.comment"></textarea>
						</div>

					</template>
					<div class="confirmation-dialog-button-container">
						<button class="confirmation-modal-button cancel" @click="closeSurvey">
							{{ $t('common.cancel') }}
						</button>
						<button class="confirmation-modal-button" :class="isEverythingSelected() ? '' : 'disabled'" @click="submitCurrentSurvey">
							{{ $t('common.submit') }}
						</button>
					</div>
				</div>

			</div>
		</div>

		<div :class="'confirmation-popup-backdrop'"></div>
	</div>
	</template>

<script>

import Vue from "vue";
import {submitSurvey} from '@/drc/services/drc-request-service';
import {NOTIFICATION_TYPE} from "@/common/utils/constants";
import * as STATISTIC_SERVICE from "@/common/services/statistic-service";
import {getActiveSurvey} from "@/drc/services/drc-graphql-service";

export default {
	name: "Survey",
  data() {
    return {
      doShowDialog: false,
			questions:[
				{
					"id": 1,
					"question": "Q1. On a scale of 1 to 5, how satisfied are you with the resources available on this platform?",
					"answers": [
						{
							"id": 1,
							"text": "1 - Not satisfied at all"
						},
						{
							"id": 2,
							"text": "2 - Somewhat dissatisfied"
						},
						{
							"id": 3,
							"text": "3 - Neutral"
						},
						{
							"id": 4,
								"text": "4 - Satisfied"
						},
						{
							"id": 5,
							"text": "5 - Very satisfied"
						}
					],
					"type": "SINGLE",
					"comment": "",
					"answer": []
				},{
					"id": 2,
					"question": "Q2. What do you find most valuable about our resources? (Select all that apply)",
					"answers": [
						{
							"id": 6,
							"text": "Quality of information"
						},
						{
							"id": 7,
							"text": "Ease of access/navigation"
						},
						{
							"id": 8,
							"text": "Relevance to my needs"
						},
						{
							"id": 9,
							"text": "Regular updates"
						},
						{
							"id": 10,
							"text": "Other, please specify:"
						}
					],
					"type": "MULTIPLE",
					"comment": "",
					"answer": []
				},
				{
					"id": 3,
					"question": "Q3. How easy is it to find the information you need on our platform?",
					"answers": [
						{
							"id": 11,
							"text": "Very easy"
						},
						{
							"id": 12,
							"text": "Somewhat easy"
						},
						{
							"id": 13,
							"text": "Neutral"
						},
						{
							"id": 14,
							"text": "Somewhat difficult"
						},
						{
							"id": 15,
							"text": "Very difficult"
						}
					],
					"type": "SINGLE",
					"comment": "",
					"answer": []
				},
				{
					"id": 4,
					"question": "Q4. How often do you use the resources on our platform?",
					"answers": [
						{
							"id": 16,
							"text": "Daily"
						},
						{
							"id": 17,
							"text": "Weekly"
						},
						{
							"id": 18,
							"text": "Monthly"
						},
						{
							"id": 19,
							"text": "Rarely"
						}
					],
					"type": "SINGLE",
					"comment": "",
					"answer": []
				},
				{
					"id": 5,
					"question": "Q5. What features or improvements would you like to see in future updates? (Open-ended)",
					"answers": [],
					"type": "TEXT",
					"comment": "",
					"answer": []
				}
			],
			survey: {},
			loader: null,
    }
  },
	methods: {
		onConfirm() { },
		onCancel() { },
		isEverythingSelected(){
			return this.questions.every(question => {
				if (question.answerType === 'MULTIPLE') {
					return question.answer.length > 0;
				} else if (question.answerType === 'SINGLE') {
					return question.answer > 0;
				} else if (question.answerType === 'TEXT') {
					return question.comment.trim().length > 0;
				}
				return false;
			});
		},
		submitCurrentSurvey() {
			if (!this.isEverythingSelected()) {
				this.showNotification(`${this.$t('notifications.surveyNotCompleted')}`, NOTIFICATION_TYPE.ERROR);
				return;
			}
			this.doShowDialog = false;
			this.loader.show({text: '', description: '', buttonText: null, isBlue: false, onCancel: () => {}});
			let dataToPost = [];
			this.questions.forEach(question => {
				let answers;
				if(question.answerType === 'SINGLE') {
					answers = [question.drcSurveyAnswers.find(ans => ans.id === question.answer)].map(q => ({
						id: q.id,
						text: q.answer
					}));
				}else if (question.answerType === 'MULTIPLE') {
					answers = question.drcSurveyAnswers.filter(ans => question.answer.includes(ans.id)).map(q => ({
						id: q.id,
						text: q.answer
					}));
				}else{
					answers = [{id: null, text: question.comment}];
				}

				let questionData = {
					id: question.id,
					question: question.question,
					answers: answers,
					type: question.answerType,
					comment: question.comment,
				};
				dataToPost.push(questionData);
			});

			submitSurvey(dataToPost, this.$store.getters.getUser.id, this.survey.id)
				.then(() => {
					this.loader.show({text: '', description: '', buttonText: null, isBlue: false, onCancel: () => {}});
					this.showNotification(`${this.$t('notifications.surveySuccessfullySubmitted')}`, NOTIFICATION_TYPE.SUCCESS)
					this.onConfirm();
					this.resetSurvey();
					this.addSubmittedSurveyStatistic();
				})
				.catch(() => {
					this.showNotification(`${this.$t('notifications.errorSubmittingSurvey')}`, NOTIFICATION_TYPE.ERROR)
					// this.doShowDialog = true;
				}).finally(() => {
					this.loader.hide();
				});

		},
		addSubmittedSurveyStatistic() {
			const now = new Date();
			this.$gtag.event(`drc_submitted_survey`, {
				event_type: "drc_submitted_survey",
				event_category: "drc",
				event_page: `${this.$route.name}`,
				event_label: ``,
				event_location: this.$route.name,
				event_path: this.$route.path,
				user_id: this.$store.getters.getUserId,
				user_name: this.$store.getters.getUserName,
				user_email: this.$store.getters.getUserEmail,
				year: now.getFullYear(),
				month: now.getMonth() + 1,
				day: now.getDate(),
			});
			const props = {
				action: `drc_submitted_survey`,
				comment: JSON.stringify({current_route: `${window.location.href}`, page: `${this.$route.name}`})
			}
			STATISTIC_SERVICE.addDrcStatistic(props);
		},
		toggleOptions(option, question) {
			if (question.answerType === 'MULTIPLE') {
				if (question.answer.includes(option.id)) {
					question.answer = question.answer.filter(id => id !== option.id);
				} else {
					question.answer.push(option.id);
				}
			} else if (question.answerType === 'SINGLE') {
				question.answer = option.id;
			}
		},
		loadInitialData(){
			getActiveSurvey().then(response => {
				if (response) {
					this.survey = response;
					this.questions = response.drcSurveyQuestions.map(question => {
						return {
							...question,
							answer: question.answerType === 'MULTIPLE' ? [] : '',
							comment: '',
						};
					});
					this.loader.hide();
					this.doShowDialog = true;
				} else {
					this.loader.hide();
					this.showNotification(`${this.$t('notifications.errorLoadingSurvey')}`, NOTIFICATION_TYPE.ERROR);
				}
			}).catch(() => {
				this.loader.hide();
				this.showNotification(`${this.$t('notifications.errorLoadingSurvey')}`, NOTIFICATION_TYPE.ERROR);
			})
		},
		openSurvey({onConfirm, onCancel, loader}) {
			this.loader = loader;
			this.loader.show({text: '', description: '', buttonText: null, isBlue: false, onCancel: () => {}});
			this.loadInitialData();
			this.onConfirm = onConfirm;
			this.onCancel = onCancel;
		},
		closeSurvey() {
			this.doShowDialog = false;
			this.resetSurvey();
			this.onCancel();
		},
		resetSurvey(){
			this.questions.forEach(question => {
				question.answer = [];
				question.comment = '';
			});
		},
	},
	created() {
		Vue.prototype.$survey = {
			closeSurvey: this.closeSurvey,
			openSurvey: this.openSurvey
		};
	},
}
/*
HOW TO USE:
	this.$survey.openSurvey({onConfirm: () => {
			this.showNotification(`${this.$t('notifications.error')}`, NOTIFICATION_TYPE.SUCCESS);
		},
			onCancel: () => {
				this.showNotification(`${this.$t('notifications.error')}`, NOTIFICATION_TYPE.ERROR);
		}
	})
 */

</script>



<style scoped lang="scss">
.survey-popup{
	.confirmation-dialog{
		margin-top: 50px;
		width: 100%;
		max-width: 600px;
		height: 100%;
		max-height: 600px;
		.confirmation-dialog-button-container{
			display: flex;
			div{
				flex:1;
			}
			.confirmation-modal-button.disabled{
				background: #A6A6A6;
				cursor: not-allowed;
			}
		}
		.survey-container{
			height: 500px;
			overflow-y: scroll;
			.question{
				.question-text{
					font-family: Roboto;
					font-weight: 500;
					font-size: 17px;
					line-height: 22px;
					letter-spacing: 0px;
					margin: 16px 0;
				}
				.question-options {
					font-family: Roboto;
					font-weight: 400;
					font-size: 16px;
					line-height: 21px;
					letter-spacing: 0px;
					color: #161616;
					accent-color: #FFB81C;

					.option{
						cursor: pointer;
						display: flex;
						*{
							cursor: pointer;
						}
					}

					&.question-options-single{
						display: flex;
						flex-direction: column;
						gap: 10px;
						margin: 10px 0;
						input{
							-webkit-appearance: none;
							appearance: none;
							height: 16px;
							width: 16px;
							background: white;
							border-radius: 50%;
							border: 1px solid grey;
							margin-right: 10px;
							&:checked{
								background: #ffb81c;
							}
						}
					}
					&.question-options-multiple{
						display: flex;
						flex-direction: column;
						gap: 10px;
						margin: 10px 0;
						input{
							height: 16px;
							width: 16px;
							background: white;
							border: 1px solid grey;
							margin-right: 10px;
							&:checked{
								background: #ffb81c;
							}
						}
					}
				}
				textarea{
					width: 100%;
					gap: 12px;
					padding: 16px;
					resize: none;
					border: 1px solid #A6A6A6;
					background: #FFFFFF;
					font-family: Roboto;
					font-weight: 400;
					font-size: 16px;
					line-height: 21px;
					letter-spacing: 0px;
				}
			}
		}
	}
}


</style>
